import { render, staticRenderFns } from "./oneUserInProject.vue?vue&type=template&id=a5b5bd70&"
import script from "./oneUserInProject.vue?vue&type=script&lang=js&"
export * from "./oneUserInProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports